
$(document).ready(function(){   
			$(".nav-tabs a").click(function(){
		    	$(this).tab('show');
		  	});
			$(document).on('click','#video-hemp-top', function() { 
			     $('#video-top .video-overlay').css({"opacity": "1", "visibility": "visible"});
			});

			$(document).on('click','#polera', function() { 
			     $('#polera-over.overlay-sobre').css({"opacity": "1", "visibility": "visible"});
			});

			$(document).on('click','#polera-over', function() { 
			     $('#polera-over.overlay-sobre').css({"opacity": "0", "visibility": "hidden"});
			});

		  	var owl = $('.owl-sobreHemp');
		    owl.owlCarousel({
		    	margin: 10,
		 		navText: ['<img src="https://cdn.shopify.com/s/files/1/1568/2063/files/left-arrow.svg?7638" />','<img src="https://cdn.shopify.com/s/files/1/1568/2063/files/right-arrow.svg?7638" />'],
		       	nav: true,
		       	dots: false,
		       	loop: true,
		       	responsive: {
		        	 0: {
		            	items: 1,
		            	dots: true,
		            	nav: false
		         	},
		         	600: {
		            	items: 1,
		            	dots: false
		         	},
		         	1000: {
		            	items: 1,
		            	dots: false
		         	}
		       }
		    });

		    var owl = $('.owl-carousel');
		    owl.owlCarousel({
		    	margin: 10,
		 		navText: ['<img src="https://cdn.shopify.com/s/files/1/1568/2063/files/left-arrow.svg?7638" />','<img src="https://cdn.shopify.com/s/files/1/1568/2063/files/right-arrow.svg?7638" />'],
		       	nav: true,
		       	dots: false,
		       	loop: true,
		       	responsive: {
		        	 0: {
		            	items: 1,
		            	dots: true,
		            	nav: false
		         	},
		         	600: {
		            	items: 2
		         	},
		         	1000: {
		            	items: 3
		         	}
		       }
		    });  
  
		});